import { Project } from '../types';
import { projects } from '../data/portfolioData';

// import datoCMSClient from './datoCMSClient';

export async function getProjects(): Promise<Project[]> {
  return projects;
}
